import React from "react";
import "./Breadcrum.scss";
import PropTypes from "prop-types"; // To validate props if needed
import { Link, Links } from "react-router-dom";

const Breadcrumb = ({ title, backgroundImage, height = "30vh" }) => {
  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`, // Dynamically set the background image
    backgroundSize: "cover", // Ensures the background image covers the entire container
    backgroundPosition: "center bottom", // Positions the background image ingit the center horizontally and at the bottom vertically
    backgroundRepeat: "no-repeat", // Ensures the image doesn't repeat
    height: height, // Adjusts the height of the container to 30% of the viewport height
    display: "flex", // Enables flexbox layout
    justifyContent: "center", // Centers content horizontally
    alignItems: "center", // Centers content vertically
    padding: "110px 0", // Adds padding to the top and bottom (adjust as needed)
    textAlign: "center", // Centers text horizontally within the container
  };

  return (
    <div className="page-heading header-text" style={backgroundStyle}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <span className="breadcrumb">
              <Link to="/">Home</Link> / {title}
            </span>
            <h3>{title}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

// PropTypes validation
Breadcrumb.propTypes = {
  title: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired, // Ensure background image is a string URL
};

export default Breadcrumb;
